/* eslint-disable camelcase */
import React from 'react';
import { ColorBatch } from 'components';
import { dateFormat, creditStatusColorMap, creditsStatusName } from 'enums';
import { statusCol } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var contractReferenceColumns = [{
  name: '№ договор',
  value: 'number',
  width: '110px'
}, {
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Сума по дог.',
  render: function render(_ref) {
    var contract_amount = _ref.contract_amount,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "contract_amount"
    }, contract_amount, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Лихва',
  render: function render(_ref2) {
    var total_contract_interest = _ref2.total_contract_interest,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_contract_interest"
    }, total_contract_interest, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Такса посещение',
  render: function render(_ref3) {
    var home_visit_fee = _ref3.home_visit_fee,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "home_visit_fee"
    }, home_visit_fee, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Начална дата',
  value: 'start_date',
  dateTimeFormat: dateFormat
}, {
  name: 'Крайна Дата',
  value: 'end_date',
  dateTimeFormat: dateFormat
}, {
  name: 'Мес. вноска',
  render: function render(_ref4) {
    var monthly_payment = _ref4.monthly_payment,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "monthly_payment"
    }, monthly_payment, " ", currency);
  }
}, {
  name: 'Бр. вноски',
  value: 'period_months',
  width: '95px'
}, {
  name: 'Плат. главница',
  render: function render(_ref5) {
    var total_payed_principal = _ref5.total_payed_principal,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_principal"
    }, total_payed_principal, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Плат. лихви',
  render: function render(_ref6) {
    var total_payed_interest = _ref6.total_payed_interest,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_interest"
    }, total_payed_interest, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Плат. такса',
  render: function render(_ref7) {
    var total_payed_fee = _ref7.total_payed_fee,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_fee"
    }, total_payed_fee, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Ост. главница',
  render: function render(_ref8) {
    var total_rest_principal = _ref8.total_rest_principal,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_rest_principal"
    }, total_rest_principal, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Ост. лихви',
  render: function render(_ref9) {
    var total_rest_interest = _ref9.total_rest_interest,
        currency = _ref9.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_rest_interest"
    }, total_rest_interest, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Ост. такса',
  render: function render(_ref10) {
    var total_rest_fee = _ref10.total_rest_fee,
        currency = _ref10.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_rest_fee"
    }, total_rest_fee, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Статус',
  render: function render(_ref11) {
    var status = _ref11.status,
        refinanced_from_credit = _ref11.refinanced_from_credit;
    return ___EmotionJSX("div", {
      css: statusCol
    }, ___EmotionJSX(ColorBatch, {
      type: creditStatusColorMap[status]
    }, creditsStatusName[status]), refinanced_from_credit && ___EmotionJSX(ColorBatch, {
      type: "purple"
    }, "\u0420\u0415\u0424\u0418\u041D\u0410\u041D\u0421"));
  },
  width: '120px'
}];